// frontend/src/components/chat/AttachmentPreview.jsx
// Preview component for files before sending

import React, { useState, useEffect } from "react";
import { getFileIcon, formatFileSize } from "../../utils/chatAttachmentApi";

const AttachmentPreview = ({ file, uploadProgress, onRemove, isUploading }) => {
  const [preview, setPreview] = useState(null);
  const isImage = file.type.startsWith("image/");

  // Generate preview for images
  useEffect(() => {
    if (!isImage) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      setPreview(e.target.result);
    };
    reader.readAsDataURL(file);

    return () => {
      setPreview(null);
    };
  }, [file, isImage]);

  return (
    <div className="attachment-preview">
      <div className="attachment-preview-content">
        {isImage && preview ? (
          <div className="attachment-image-preview">
            <img src={preview} alt={file.name} />
          </div>
        ) : (
          <div className="attachment-file-preview">
            <i className={`bi ${getFileIcon(file.type)}`}></i>
          </div>
        )}

        <div className="attachment-info">
          <div className="attachment-name" title={file.name}>
            {file.name.length > 25
              ? file.name.substring(0, 22) + "..."
              : file.name}
          </div>
          <div className="attachment-size">{formatFileSize(file.size)}</div>
        </div>

        {!isUploading && (
          <button
            type="button"
            className="attachment-remove-btn"
            onClick={onRemove}
            aria-label="Remove attachment"
          >
            <i className="bi bi-x"></i>
          </button>
        )}
      </div>

      {/* Upload progress bar */}
      {isUploading && (
        <div className="attachment-progress">
          <div
            className="attachment-progress-bar"
            style={{ width: `${uploadProgress}%` }}
          />
        </div>
      )}
    </div>
  );
};

export default AttachmentPreview;
